export default "__VITE_ASSET__36439fc7__"